import { PrintSide } from './print-side.enum';

export const PrintSidesSorted = [PrintSide.Both, PrintSide.Front, PrintSide.Back];
